<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Sales</h4>
    </div>
    <div class="card-body">
      <v-server-table :url="`/v1/sales`" :columns="columns" :options="options">
        <template slot="id" slot-scope="props">
          <code>{{ props.row.id }}</code>
        </template>

        <template slot="createdAt" slot-scope="props">
          <div>{{ props.row.createdAt | moment('YYYY-MM-DD HH:mm A') }}</div>
        </template>

        <template slot="amount" slot-scope="props">
          <span>{{ props.row.amount | money(props.row.currency) }}</span>
        </template>

        <template slot="panLastFour" slot-scope="props">
          <div>************{{ props.row.panLastFour }}</div>
        </template>

        <template slot="links" slot-scope="props">
          <router-link :to="`/account/sales/${props.row.id}`" class="btn btn-default btn-sm">
            View &nbsp;
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import accounting from "accounting";

const columns = [
  "id",
  "amount",
  "cardScheme",
  "cardType",
  "panLastFour",
  "createdAt",
  "links"
];

export default {
  name: "SalesList",
  data() {
    return {
      columns,
      options: {
        columnsDropdown: false,
        headings: {
          id: "Sale ID",
          amount: "Amount",
          cardScheme: "Scheme",
          cardType: "Card type",
          panLastFour: "PAN",
          createdAt: "Date"
        },
        sortable: _.initial(columns),
        filterable: _.initial(columns),
        listColumns: {
          cardScheme: [
            {
              id: "visa",
              text: "Visa"
            },
            {
              id: "mastercard",
              text: "Mastercard"
            },
            {
              id: "american_express",
              text: "American Express"
            }
          ],
          cardType: [
            {
              id: "credit",
              text: "Credit"
            },
            {
              id: "debit",
              text: "Debit"
            },
            {
              id: "prepaid",
              text: "Prepaid"
            }
          ]
        }
      }
    };
  }
};
</script>